import { FC } from "react";
import { useTranslation } from "react-i18next";
import { BaseComplexSidebarLink, ComplexLinkProps } from "./BaseComplexSidebarLink";
import { SettingsIcon } from "../../../../assets/icons/Icons";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../LinkTypes";
import { theme } from "../../../../theme";

export const ConfigurationComplexLink: FC<ComplexLinkProps & { submenuLinks?: string[] }> = ({
    activePathname,
    collapsed,
    showText,
}) => {
    const { t } = useTranslation();

    const links = [
        { linkName: SidebarLinkTypes.appDesign, path: SidebarLinkPathTypes.appDesign },
    ];

    return (
        <BaseComplexSidebarLink
            activePathname={activePathname}
            collapsed={collapsed}
            showText={showText}
            icon={<SettingsIcon />}
            label={t(SidebarLinkTypes.configuration)}
            links={links}
            sxPopover={{ "&:hover": { color: theme.palette.primary.main } }}
        />
    );
};
